import React from "react"
import { HeaderSection } from "../../common/headers/HeaderSection";
import FreeCourseScheduleSection from "./FreeCourseBanner";
import { CourseSchedule } from "@/interfaces/CourseSchedule";

const videogameWeek1FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 1,
        programTitle: 'Video Game',
        date: '8 Desember 2023',
        day: 'Jumat',
        time: '19.00 - selesai',
    },
];
const videogameWeek2FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 2,
        programTitle: 'Video Game',
        date: '14 Desember 2023',
        day: 'Kamis',
        time: '19.00 - selesai',
    },
];
const videogameWeek3FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 3,
        programTitle: 'Video Game',
        date: '21 Desember 2023',
        day: 'Kamis',
        time: '19.00 - selesai',
    },
];

const VideoGameFreeCourseSchedule = () => {
    return (
        <div className="px-5 md:px-10">
            <HeaderSection
                title="Jadwal Program"
                subtitle="Pilih dan daftar jadwal program yang tersedia"
            />
            <FreeCourseScheduleSection schedule={videogameWeek1FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={videogameWeek2FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={videogameWeek3FreeCourseSchedule} />
        </div>
    );
};

export default VideoGameFreeCourseSchedule;